import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTemplate: null,
  templateHistory: [],
  loading: false,
  error: null,
};

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;

      const existingIndex = state.templateHistory.findIndex(
        (template) => template.template_id === action.payload.template_id
      );

      if (existingIndex === -1) {
        state.templateHistory.unshift(action.payload);
      } else {
        // Move to front if already exists
        const existingTemplate = state.templateHistory.splice(
          existingIndex,
          1
        )[0];
        state.templateHistory.unshift(existingTemplate);
      }

      // Keep only last 10 templates in history
      if (state.templateHistory.length > 10) {
        state.templateHistory = state.templateHistory.slice(0, 10);
      }
    },

    clearSelectedTemplate: (state) => {
      state.selectedTemplate = null;
    },

    clearTemplateHistory: (state) => {
      state.templateHistory = [];
    },

    removeFromHistory: (state, action) => {
      state.templateHistory = state.templateHistory.filter(
        (template) => template.template_id !== action.payload
      );
    },

    setTemplateLoading: (state, action) => {
      state.loading = action.payload;
    },

    setTemplateError: (state, action) => {
      state.error = action.payload;
    },

    clearTemplateError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setSelectedTemplate,
  clearSelectedTemplate,
  clearTemplateHistory,
  removeFromHistory,
  setTemplateLoading,
  setTemplateError,
  clearTemplateError,
} = templateSlice.actions;

export default templateSlice.reducer;
